import React, { Component } from 'react';
import { loadFirebase } from '../lib/db';
import Locations from '../components/Locations';

class LocationsPage extends Component {
  static async getInitialProps() {
    let firebase = await loadFirebase();
    let db = firebase.firestore();

    let events = await new Promise((resolve, reject) => {
      db.collection('events')
        .orderBy('date')
        .get()
        .then(snapshot => {
          let data = [];
          snapshot.forEach(doc => {
            data.push({
              id: doc.id,
              ...doc.data()
            });
          });
          resolve(data);
        })
        .catch(error => {
          reject([]);
        });
    });

    return { events };
  }

  render() {
    return <Locations {...this.props} />;
  }
}

export default LocationsPage;
